"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactCompoundSlider = require("react-compound-slider");

var _index = require("./index");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RangeSlider = function RangeSlider(_ref) {
  var initialValues = _ref.initialValues,
      onChanged = _ref.onChanged,
      handlePrefix = _ref.handlePrefix,
      min = _ref.min,
      max = _ref.max,
      step = _ref.step,
      mode = _ref.mode,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["initialValues", "onChanged", "handlePrefix", "min", "max", "step", "mode", "className"]);

  var _useState = (0, _react.useState)(initialValues.slice()),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  (0, _react.useEffect)(function () {
    setValues(initialValues.slice());
  }, [initialValues]);
  var sliderStyle = {
    position: 'relative',
    width: 'calc(100% - 56px)',
    maxWidth: 'calc(100rem - 56px)',
    marginRight: 56,
    height: 36,
    paddingRight: 50
  };

  var onChange = function onChange(newValues) {
    setValues(newValues);
    onChanged(newValues);
  };

  return /*#__PURE__*/_react.default.createElement(_reactCompoundSlider.Slider, _extends({
    rootStyle: sliderStyle,
    domain: [min, max],
    onChange: onChange,
    values: values,
    step: step,
    mode: mode,
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement(_index.Rail, null), /*#__PURE__*/_react.default.createElement(_reactCompoundSlider.Handles, null, function (_ref2) {
    var handles = _ref2.handles,
        getHandleProps = _ref2.getHandleProps;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "slider-handles"
    }, handles.map(function (handle) {
      return /*#__PURE__*/_react.default.createElement(_index.Handle, {
        key: handle.id,
        handle: handle,
        getHandleProps: getHandleProps,
        handlePrefix: handlePrefix
      });
    }));
  }));
};

RangeSlider.defaultProps = {
  initialValues: [0, 100],
  min: 0,
  max: 100,
  step: 1,
  mode: 2
};
RangeSlider.propTypes = {
  /** The initial values of the slider. */
  initialValues: _propTypes.array.isRequired,

  /** Function to be run when the user releases the handle on a new value. (Returns a variable containing the current values.) */
  onChanged: _propTypes.func,

  /** Optional prefix to be shown in the handles. */
  handlePrefix: _propTypes.string,

  /** Minimum value of the slider. */
  min: _propTypes.number.isRequired,

  /** Maximum value of the slider. */
  max: _propTypes.number.isRequired,

  /** Step by which the values change. */
  step: _propTypes.number.isRequired,

  /** The mode of the slider. (Read more here: https://sghall.github.io/react-compound-slider/#/component-api/slider) */
  mode: _propTypes.number,

  /** Optional className to be applied. */
  className: _propTypes.string,

  /** Optional additional props to be passed. */
  otherProps: _propTypes.object
};
var _default = RangeSlider;
exports.default = _default;